export default __webpack_public_path__ + "box-side-fix.jpg";